const LONG_NOTIFICATION_DURATION = 7000;

const OBSERVER_THRESHOLDS = {
  ZERO: [0],
  FULL: [1],
  HALF: [0.5, 1],
  QUARTER: [0.25, 0.5, 0.75, 1]
};

const PAGE_SECTION_NAME = {
  HOME: 'HOME',
  YOUR_SKIN: 'YOUR_SKIN',
  YOUR_INGREDIENTS: 'YOUR_INGREDIENTS',
  YOUR_TREATMENT: 'YOUR_TREATMENT',
  YOUR_ROUTINE: 'YOUR_ROUTINE',
  MAKING_SERUM: 'MAKING_SERUM'
};

const MAIN_PAGE_SECTIONS = [
  {
    sectionName: PAGE_SECTION_NAME.HOME,
    labelKey: 'section.home.label',
    route: { name: 'MainPage', hash: '#home' }
  },
  {
    sectionName: PAGE_SECTION_NAME.YOUR_TREATMENT,
    labelKey: 'section.yourTreatment.label',
    route: { name: 'MainPage', hash: '#your-treatment' }
  },
  {
    sectionName: PAGE_SECTION_NAME.YOUR_ROUTINE,
    labelKey: 'section.yourRoutine.label',
    route: { name: 'MainPage', hash: '#your-routine' }
  },
  {
    sectionName: PAGE_SECTION_NAME.YOUR_SKIN,
    labelKey: 'section.yourSkin.label',
    route: { name: 'MainPage', hash: '#your-skin' }
  },
  {
    sectionName: PAGE_SECTION_NAME.YOUR_INGREDIENTS,
    labelKey: 'section.yourIngredients.label',
    route: { name: 'MainPage', hash: '#your-ingredients' }
  },
  {
    sectionName: PAGE_SECTION_NAME.MAKING_SERUM,
    labelKey: 'section.freshlyBlended.label',
    route: { name: 'MainPage', hash: '#making-serum' }
  }
];

const MIN_PRICE_DELIVERY_FIELD_PATHS = [
  ['minTotalPriceForFreeDeliveryClassicNoSerum'],
  ['minTotalPriceForFreeDeliveryExpressNoSerum'],
  ['minTotalPriceForFreeDeliveryClassicWithSerum'],
  ['minTotalPriceForFreeDeliveryExpressWithSerum']
];

const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other'
};

const SCREEN_SIZE = {
  EXTRA_SMALL: 'extra-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};

const MEDIA_TYPE = {
  VIDEO_MP4: 'video/mp4'
};

const RESPONSIVE_VIDEO_SIZE_MAP = {
  [SCREEN_SIZE.EXTRA_SMALL]: SCREEN_SIZE.SMALL,
  [SCREEN_SIZE.SMALL]: SCREEN_SIZE.MEDIUM,
  [SCREEN_SIZE.MEDIUM]: SCREEN_SIZE.LARGE,
  [SCREEN_SIZE.LARGE]: SCREEN_SIZE.LARGE,
  [SCREEN_SIZE.EXTRA_LARGE]: SCREEN_SIZE.LARGE
};

export {
  LONG_NOTIFICATION_DURATION,
  OBSERVER_THRESHOLDS,
  PAGE_SECTION_NAME,
  MAIN_PAGE_SECTIONS,
  MIN_PRICE_DELIVERY_FIELD_PATHS,
  GENDER,
  SCREEN_SIZE,
  MEDIA_TYPE,
  RESPONSIVE_VIDEO_SIZE_MAP
};
